'use strict';

/**
 * @ngdoc filter
 * @name courseApp.filter:liftPassFilter
 * @function
 * @description
 * # liftPassFilter
 * Filter in the courseApp.
 */
angular.module('courseApp')
    .filter('liftPassFilter', function () {
        return function (input) {
            return input ? 'ja' : 'JK';
        };
    });
